import getSelectedMediaElementsObjects from 'editor/src/store/design/selector/getSelectedMediaElementsObjects';
import { MediaText } from 'editor/src/store/design/types';
import {
  getSelectionFillMode,
  getTextStyle,
  getTextStyleUpdateFromElement,
  isTextStyleModified,
  isTextStyleProtected,
} from 'editor/src/store/design/util/textStyles';
import type { ThunkDispatch } from 'editor/src/store/hooks';
import type { RootState } from 'editor/src/store/index';

import updateTextStyleOperation, { TextStyleUpdateResult } from './updateTextStyleOperation';

/**
 * GAPI-61895: "Update <style> to match" — the style takes the look of the selected
 * modified text, and every text following it (except the ones the user may not edit,
 * see isTextStyleProtected) is rewritten to match, overwriting their own modifications.
 * One undo step (updateTextStyleOperation). Only what the style governs is copied.
 */
const updateTextStyleFromSelectionOperation =
  (styleId: string) =>
  (dispatch: ThunkDispatch, getState: () => RootState): Promise<TextStyleUpdateResult> => {
    const state = getState();
    const style = getTextStyle(state.design.designData, styleId);
    if (!style) {
      return Promise.resolve('skipped');
    }
    const candidates = getSelectedMediaElementsObjects(state).filter(
      (element): element is MediaText =>
        element?.type === 'text' && element.extra.textStyleId === styleId && !isTextStyleProtected(state, element),
    );
    const fillMode = getSelectionFillMode(state);
    const source = candidates.find((text) => isTextStyleModified(style, text, fillMode));
    if (!source) {
      return Promise.resolve('skipped');
    }
    return dispatch(updateTextStyleOperation(styleId, getTextStyleUpdateFromElement(style, source, fillMode)));
  };

export default updateTextStyleFromSelectionOperation;
